/**
 * Хост c API. Меняется в зависимости от переменной окружения
 */
export const CONFIG_BASE_URL = process.env.REACT_APP_API_BASE_PATH

/**
 * Вкладки сущностей в хедере
 */
export const HEADER_TABS = [
  Object.freeze({ name: 'users', label: 'Сотрудники' }),
  Object.freeze({ name: 'controllers', label: 'Точки доступа' }),
  Object.freeze({ name: 'events', label: 'События' }),
]

/**
 * Вкладки для карточки сотрудника
 */
export const CARD_USER_TABS = Object.freeze({
  PERSONAL: 'personal',
  ACCESS: 'access',
})

/**
 * Настройки для пагинации по умолчанию
 */
export const SETTINGS_PAGINATION = Object.freeze({
  COUNT_PER_PAGE: 10,
  COUNT_PER_PAGE_MAX: 50,
  PAGE_NUMBER: 1,
})

export const MODAL_ALERT_TYPES = Object.freeze({
  TYPE_WARNING: 'Предупреждение',
  TYPE_ERROR: 'Ошибка',
})
